import { TreeRepBuilder } from "../tree-rep-builder";
import { WordTreeNode } from "./word-tree-node";
import { TreeNode } from "../lib/tree-node";
import { Node } from '../../graph/lib/node';
import { TreeEdge } from "../lib/tree-edge";

//Deprecated
export abstract class WordTreeRepBuilder extends TreeRepBuilder {

    abstract leftClickTreeNode(treeNode: TreeNode);


    createNewNode(row: number, col: number, id: number,
        parentNode: TreeNode, content: [string], alphabet: [string],
        depth: number, maxWidth?: number): TreeNode {
        let node: WordTreeNode = new WordTreeNode(row, col, id, parentNode,
            content, alphabet, depth);
        node.setMaxTextWidth(maxWidth);
        return node;
    }

    addEdge(from: Node, to: Node) {
        if (from == to)
            return;

        //Node has been deleted, hence cant be used to connect
        if (this.nodes.indexOf(from) == -1 || this.nodes.indexOf(to) == -1) {
            return;
        }

        from.addNeighbor(to);
        if (!this.existsEdge(from, to)) {
            let edge: TreeEdge = new TreeEdge(from, to);
            edge.setNearFactor(1);
            this.edges.push(edge);
        }
        this.update();

    }
}
